// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { useFindDatasetById } from '../../state/hooks/DatasetHooks';
import { useCurrentScenarioData } from '../../state/hooks/ScenarioHooks';
import { useTwingraphQueriesStatus } from '../../state/wizard/WizardHooks';

export const useGanttWizard = () => {
  const status = useTwingraphQueriesStatus();
  const scenarioData = useCurrentScenarioData();
  const datasetId = scenarioData.datasetList[0];
  const findDatasetById = useFindDatasetById();
  const datasetData = findDatasetById(datasetId);
  const doesDatasetExist = !!datasetData;
  const isDatasetTwingraph = datasetData?.ingestionStatus !== null;
  const datasetIngestionStatus = datasetData?.ingestionStatus;

  return { status, datasetId, doesDatasetExist, isDatasetTwingraph, datasetIngestionStatus };
};
